import React from 'react';
import { useMenuContext } from '../../context';
import { Stack } from 'src/components/mui';

type Props = {
  hasBeenOpened: boolean;
  tooltipOn: boolean;
  leftOffset: number;
  children: React.ReactNode;
};

export default function Container({ hasBeenOpened, tooltipOn, leftOffset, children }: Props) {
  const { rtl } = useMenuContext();
  return (
    <Stack
      direction={rtl ? 'row-reverse' : 'row'}
      spacing={2}
      alignItems="center"
      sx={{
        position: 'absolute',
        top: '95px',
        left: tooltipOn ? `${-leftOffset}px` : `${-40}px`,
        zIndex: 1,

        '@keyframes pulse': {
          '0%': {
            transform: 'scale(1)',
          },
          '50%': {
            transform: 'scale(1.05)',
          },
          '100%': {
            transform: 'scale(1)',
          },
        },
        animation: !hasBeenOpened ? 'pulse 2s infinite' : 'none',
      }}
    >
      {children}
    </Stack>
  );
}
